import { createSelector } from 'reselect';

const getLinkPreview = createSelector(
  state => state.linkPreviews,
  (_, url) => url,
  (linkPreviews, url) => {
    const entry = linkPreviews[url];
    if (!entry || entry.expires <= Date.now()) return null;
    if (entry.isFetching || entry._error || !entry.title) return null;
    return entry;
  },
);

export default getLinkPreview;
